import {UserService} from '../services';
import {Directive, OnInit, TemplateRef, ViewContainerRef, Input} from '@angular/core';

@Directive({selector: '[appShowCompanyAuthed]'})
export class ShowCompanyAuthedDirective implements OnInit {

  condition: boolean;

  constructor(
    private templateRef: TemplateRef<any>,
    private userService: UserService,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.userService.isAuthenticated.subscribe(
      (isAuthenticated) => {
        if ((isAuthenticated && this.condition && this.userService.getCurrentUser().role.name === 'entreprise')
        || (isAuthenticated && !this.condition && this.userService.getCurrentUser().role.name !== 'entreprise')) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      }
    );
  }

  @Input()
  set appShowCompanyAuthed(condition: boolean) {
    this.condition = condition;
  }
}
